import { Box, Link, Typography } from '@mui/material'
import ChevronRightIcon from '@mui/icons-material/ChevronRight'
import { type CollectionBuilding, type CollectionDistrict, P2PBuildingIndexStatus } from '../../../../models/peerToPeer/Collection'
import { completionLabel } from '../../../../models/peerToPeer/collectionLabels'
import { styles } from './ReportingOverview.styles'

export interface CardPalette { header: string, body: string }

export const CARD_PALETTES: CardPalette[] = [
  { header: 'var(--blue-500)', body: 'var(--blue-50)' },
  { header: 'var(--purple-500)', body: 'var(--purple-50)' },
  { header: 'var(--green-700)', body: 'var(--green-50)' },
  { header: 'var(--light-blue-700)', body: 'var(--blue-50)' }
]

interface Props {
  district: CollectionDistrict
  palette: CardPalette
  onOpenBuilding: (building: CollectionBuilding) => void
}

/**
 * Every building is clickable: a with-program building opens its form; a not-started or
 * no-program building opens the per-building Program Status prompt so it can be started
 * or changed.
 */
export const DistrictCard = ({ district, palette, onOpenBuilding }: Props): JSX.Element => (
  <Box sx={styles.card(palette.header)} data-testid={`p2pOverviewDistrict-${district.districtOrganizationId}`}>
    <Box sx={styles.cardHeader(palette.header)}>
      <Typography variant='subtitle2' sx={{ fontWeight: 700 }}>{district.name}</Typography>
    </Box>
    <Box sx={styles.cardBody(palette.body)}>
      {district.buildings.map(building => (
        <Box key={building.organizationBuildingId}>
          <Link
            component='button' underline='hover' onClick={() => { onOpenBuilding(building) }}
            sx={styles.buildingLink(building.status === P2PBuildingIndexStatus.NotStarted)}
            data-testid={`p2pOverviewBuilding-${building.organizationBuildingId}`}
          >
            {building.name} <ChevronRightIcon fontSize='small' />
          </Link>
          <Typography variant='caption' color='text.secondary'>{completionLabel(building)}</Typography>
        </Box>
      ))}
    </Box>
  </Box>
)
